import React, { FunctionComponent } from 'react';

import 'common/notification-tray/proact-action-modal/ProActActionModalBanner.scss';

interface Props {
    title: JSX.Element | string;
    text: JSX.Element | string;
}

export const ProActActionModalBanner: FunctionComponent<Props> = ({ title, text }) => {
    return (
        <div className="proact-action-modal-ai-banner" role="status">
            <div className="proact-action-modal-ai-banner-icon">
                <i className="icon-lightbulb-on" aria-hidden="true" />
            </div>
            <div className="proact-action-modal-ai-banner-textarea">
                <div className="proact-action-modal-ai-banner-title">{title}</div>
                <div className="proact-action-modal-ai-banner-text">{text}</div>
            </div>
        </div>
    );
};
